import {handleSendFunctionResponseToShotListAgent} from "../services/handleSendFunctionResponseToShotListAgent";
import {updateShotListHistory} from "./updateShotListHistory";

export const changeMultipleValues = async (
  changes,
  updatedChatSession,
  shotListState,
  setShotListState,
  setChatSession,
  userInfo,
  shotListHistory,
  setShotListHistory,
  historyIndex,
  setHistoryIndex
) => {
    const updatedShotListState = shotListState.map((shot, i) => {
        const changesForIndex = changes.filter(change => change.index === i);
        if (changesForIndex.length === 0) return shot;
        return changesForIndex.reduce((updatedShot, { field, new_value }) => {
            return { ...updatedShot, [field]: new_value };
        }, { ...shot }); // Start with a shallow copy of the shot
        });
    updateShotListHistory(
      shotListState,
      setShotListState,
      shotListHistory,
      setShotListHistory,
      historyIndex,
      setHistoryIndex,
      updatedShotListState
    ); 

    const responseMessage = `FunctionResponse: The changes you suggested have been made. Confirm that these are the intended changes (silently). If not, run it again. If so, respond letting the user know that the changes have been made successfully and either provide suggestions for further improvement or ask the user how else you can help. Here is the new state of the RFP: ${JSON.stringify(updatedShotListState, null, 2)}`;
    const response = {
        role: "user",
        parts: [
          {
            text: responseMessage
          }
        ]
    }
    await handleSendFunctionResponseToShotListAgent(response, updatedChatSession, setChatSession, userInfo);
}